import React from 'react';
import logo from '../images/logo-t.png';
import './Footer.css';

export default function Footer() {
  const EMAIL = 'contact@deimd.com';
  const PHONE_DISPLAY = '(410) 356-1095';
  const PHONE_TEL = '+14103561095';

  return (
    <footer id="footer" className="footer-container">
      <div className="footer-content">

        <div className="footer-brand">
          <img
            src={logo}
            alt="DEI Engineering logo"
            className="footer-logo"
          />
          <small className="website-rights">
            © {new Date().getFullYear()} Dhillon Engineering Inc. All rights reserved.
          </small>
        </div>

        <div className="panel panel-contact">
          <h4>Contact Us</h4>

          <div className="contact-list">
            {/* Email */}
            <div className="contact-item">
              <span className="contact-icon" aria-hidden="true">
                <i className="fas fa-envelope" />
              </span>
              <div className="contact-text">
                <span className="contact-label">Email</span>
                <a className="contact-value" href={`mailto:${EMAIL}`}>
                  {EMAIL}
                </a>
              </div>
            </div>

            {/* Phone */}
            <div className="contact-item">
              <span className="contact-icon" aria-hidden="true">
                <i className="fas fa-phone" />
              </span>
              <div className="contact-text">
                <span className="contact-label">Phone</span>
                <a className="contact-value tel" href={`tel:${PHONE_TEL}`}>
                  {PHONE_DISPLAY}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Connect panel */}
        <div className="panel panel-connect">
          <h4>Connect</h4>
          <div className="social-icons">
            <a
              className="social-icon-link linkedin"
              href="https://www.linkedin.com/company/dhillon-engineering-inc/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <i className="fab fa-linkedin" />
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
